import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import {
  validationFooterSchema,
  CreateFooter,
  validationBodySchema,
  CreateBody,
  validationHeaderSchema,
  CreateHeader,
} from "../../Ai-Saas/CreateAIData/fieldsConfig";
import DynamicForm from "../../Ai-Saas/CreateAIData/createHeader";
import CreateAiFooter from "../../Ai-Saas/CreateAIData/createFooter";
import CreateAiBody from "../../Ai-Saas/CreateAIData/createBody";
import { useSelector } from "react-redux";

const steps = ["Create Header", "Create Body", "Create Footer"];

export default function StepperForm({ handleCloseDialog, data, otherData }) {
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());
  const [manualStepChange, setManualStepChange] = React.useState(false);
  const [updatingAgentId] = React.useState(
    localStorage.getItem("updatingAgentId")
  );

  const isStepSkipped = (step) => skipped.has(step);

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const {
    headerDataForParticular,
    bodyDataForParticular,
    footerDataForParticular,
  } = useSelector((state) => state.aiDataReducer);

  if (
    headerDataForParticular &&
    bodyDataForParticular &&
    footerDataForParticular
  ) {
    steps[0] = "Update Header";
    steps[1] = "Update Body";
    steps[2] = "Update Footer";
  } else {
    steps[0] = "Create Header";
    steps[1] = "Create Body";
    steps[2] = "Create Footer";
  }

  // read checkstructureai response
  const checkStructureResponse = useSelector(
    (state) => state?.aiDataReducer?.check_structure_ai_id?.data
  );

  React.useEffect(() => {
    if (checkStructureResponse?.header === false) {
      setActiveStep(0); // No data available
    } else if (
      checkStructureResponse?.header === true &&
      checkStructureResponse?.body === false &&
      !manualStepChange
    ) {
      setActiveStep(1); // Only header data available
    } else if (
      checkStructureResponse?.header === true &&
      checkStructureResponse?.body === true &&
      checkStructureResponse?.footer === false &&
      !manualStepChange
    ) {
      setActiveStep(2); // All data available, footer is not missing
    }
  }, [
    bodyDataForParticular,
    footerDataForParticular,
    headerDataForParticular,
    checkStructureResponse,
    manualStepChange,
  ]);

  return (
    <Box sx={{ width: "100%", padding: "1rem" }}>
      <Stepper activeStep={activeStep}>
        {steps.map((label, index) => {
          const stepProps = {};
          const labelProps = {};
          if (isStepSkipped(index)) {
            stepProps.completed = false;
          }
          return (
            <Step key={label} {...stepProps}>
              <StepLabel
                {...labelProps}
                style={{ cursor: `${updatingAgentId ? "pointer" : ""}` }}
                onClick={() => updatingAgentId && setActiveStep(index)}
              >
                {label}
              </StepLabel>
            </Step>
          );
        })}
      </Stepper>
      {activeStep === steps.length ? (
        <React.Fragment>
          <Typography
            sx={{ mt: 6, mb: 1, display: "flex", justifyContent: "center" }}
          >
            All steps completed - you&apos;re finished
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              pt: 2,
            }}
          >
            {/* <Box sx={{ flex: "1 1 auto" }} /> */}
            <Button
              variant="contained"
              color="primary"
              type="submit"
              className="d-flex justify-content-end"
              onClick={handleCloseDialog}
            >
              Close Form
            </Button>
          </Box>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Typography sx={{ mt: 2, mb: 1 }}>
            {activeStep === 0 && (
              <DynamicForm
                handleNext={handleNext}
                activeStep={activeStep}
                setActiveStep={setActiveStep}
                validationHeaderSchema={validationHeaderSchema}
              />
            )}
            {activeStep === 1 && (
              <CreateAiBody
                handleNext={handleNext}
                activeStep={activeStep}
                manualStepChange={manualStepChange}
                setManualStepChange={setManualStepChange}
                setActiveStep={setActiveStep}
                validationBodySchema={validationBodySchema}
              />
            )}
            {activeStep === 2 && (
              <CreateAiFooter
                handleNext={handleNext}
                activeStep={activeStep}
                manualStepChange={manualStepChange}
                setManualStepChange={setManualStepChange}
                setActiveStep={setActiveStep}
                handleCloseDialog={handleCloseDialog}
                validationFooterSchema={validationFooterSchema}
              />
            )}
          </Typography>
        </React.Fragment>
      )}
      <div
        style={{
          display: "Flex",
          justifyContent: "space-between",
          width: "100%",
          padding: "1rem",
        }}
      ></div>
    </Box>
  );
}
